import { render, staticRenderFns } from "./VideoCheckbox.vue?vue&type=template&id=4c37a4f1&scoped=true&"
import script from "./VideoCheckbox.vue?vue&type=script&lang=ts&"
export * from "./VideoCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCheckbox.vue?vue&type=style&index=0&id=4c37a4f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37a4f1",
  null
  
)

export default component.exports